import React from 'react';
import YandexIcon from '../../../images/new_icons/yandex_info.png';
import InstaIcon from '../../../images/new_icons/insta_info.png';
import BoostyIcon from '../../../images/new_icons/boosty_info.png';
import TikTokIcon from '../../../images/new_icons/tiktok_info.png';
import YouTubeIcon from '../../../images/new_icons/youtube_info.png';
import TwitterIcon from '../../../images/new_icons/twitter_info.png';
import TelegramIcon from '../../../images/new_icons/telegram_info.png';
import SpotifyIcon from '../../../images/new_icons/spotify_info.png';

const InfoScreen = () => {
    // Unified background is now handled by MobileApp engine

    const socialLinks = [
        {
            name: 'Яндекс',
            url: 'https://band.link/myata_yandex',
            icon: YandexIcon
        },
        {
            name: 'Instagram',
            url: 'https://instagram.com/radiomyata',
            icon: InstaIcon
        },
        {
            name: 'Boosty',
            url: 'https://boosty.to/myata',
            icon: BoostyIcon
        },
        {
            name: 'TikTok',
            url: 'https://www.tiktok.com/@radio_myata',
            icon: TikTokIcon
        },
        {
            name: 'YouTube',
            url: 'https://www.youtube.com/@radiomyata',
            icon: YouTubeIcon
        },
        {
            name: 'X',
            url: 'https://twitter.com/radiomyata',
            icon: TwitterIcon
        },
        {
            name: 'Telegram',
            url: 'https://t.me/RadioMyata',
            icon: TelegramIcon
        },
        {
            name: 'Spotify',
            url: 'https://open.spotify.com/user/31b7rfatuqf7lc76thiudm5bxxuy',
            icon: SpotifyIcon
        },
    ];

    return (
        <div className="mobile-screen info-screen">
            <h1 className="info-title">ТВОЯ МУЗЫКА.<br />ТВОЯ СТАНЦИЯ.</h1>

            {/* Сетка соцсетей */}
            <div className="social-grid">
                {socialLinks.map((link, index) => (
                    <a
                        key={index}
                        href={link.url}
                        target="_blank"
                        rel="noreferrer"
                        className="social-item"
                    >
                        <img src={link.icon} alt={link.name} style={{ width: '100%', height: '100%', display: 'block' }} />
                    </a>
                ))}
            </div>

            {/* Описание */}
            <div className="info-description">
                <p>
                    Радио Мята — интернет-радиостанция, ориентированная на
                    инди-музыку и альтернативный рок.
                </p>
                <p>
                    Это «инди-эклектичное» медиа, предлагающее ироничный взгляд на массовую
                    культуру и оригинальный подход к современной музыке.
                    Станция начала вещание в ночь с 27 на 28 сентября 2017 года.
                </p>
                <p>
                    Дополнительно доступны тематические потоки:<br />
                    <span className="stream-gold">GOLD</span> — «золотые» танцевальные хиты;<br />
                    <span className="stream-xtra">XTRA</span> — новая локальная инди-музыка;
                </p>
            </div>
        </div>
    );
};

export default InfoScreen;
